// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__GfAFg","brand":"NavBar_brand__jcEL5","links_list":"NavBar_links_list__RBZlb","active":"NavBar_active__dq9zA"};